// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

export function ActionsColumnFormatterPenyedia(
  cellContent,
  row,
  rowIndex,
  { detail }
) {
  return (
    <>
      <a
        title="Lihat Detail"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => detail(row.id_distributor)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <i className="fas fa-eye text-primary"></i>
        </span>
      </a>
    </>
  );
}

export function ActionsColumnFormatterPemungut(
  cellContent,
  row,
  rowIndex,
  { detail }
) {
  return (
    <>
      <a
        title="Lihat Detail"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => detail(row.id_pengguna)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <i className="fas fa-eye text-primary"></i>
        </span>
      </a>
    </>
  );
}

export function ActionsColumnFormatterPenyediaAplikasi(
  cellContent,
  row,
  rowIndex,
  { openEditDialog, openDocumentDialog, toggleDropdown, openViewDialog }
) {
  return (
    <>
      <a
        title="Lihat"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openViewDialog(row.id_distributor)}
      >
        {/* <span className="svg-icon svg-icon-md svg-icon-primary">
        <i className="fas fa-edit text-primary"></i>
      </span> */}
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <i className="fas fa-eye text-primary"></i>
        </span>
      </a>
      {/* <> </>

    <a
      title="Lihat Dokumen"
      className="btn btn-icon btn-light btn-hover-warning btn-sm"
      onClick={() =>
        openDocumentDialog(
          row.idDistributor
        )
      }
    >
      <span className="svg-icon svg-icon-md svg-icon-warning">
        <i className="far fa-file-alt text-warning"></i>
      </span>
    </a>
    <> </>
    <a
      title="Set Aksi"
      className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
      onClick={() =>
        toggleDropdown()
      }
    >
      <span className="svg-icon svg-icon-md svg-icon-success">
        <i className="fas fa-cog text-success"></i>
      </span>
    </a> */}
    </>
  );
}

export function ActionsColumnFormatterDashboard(
  cellContent,
  row,
  rowIndex,
  { openDetailDialog, openDeleteDialog, openCetakBps, openCetakSuket }
) {
  return (
    <>
      <a
        title="Lihat Detail"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3 my-3"
        onClick={() => openDetailDialog(row.refJenisSurat, row.noBps)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <i className="fas fa-eye text-primary"></i>
        </span>
      </a>
      {row.statusData !== 'NONAKTIF' && (
        <a
          title="Cetak Suket"
          className="btn btn-icon btn-light btn-hover-success btn-sm mx-3 my-3"
          onClick={() => openCetakSuket(row.refJenisSurat, row.noBps)}
        >
          <span className="svg-icon svg-icon-md svg-icon-dark">
            {/* <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")}
                    /> */}
            <i className="fas fa-file-signature text-success"></i>
          </span>
        </a>
      )}
      <a
        title="Cetak BPS"
        className="btn btn-icon btn-light btn-hover-info btn-sm mx-3 my-3"
        onClick={() => openCetakBps(row.noBps)}
      >
        <span className="svg-icon svg-icon-md svg-icon-dark">
          {/* <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")}
                  /> */}
          <i className="fas fa-envelope-open-text text-info"></i>
        </span>
      </a>
      {/* <a
        title="Hapus"
        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3 my-3"
        onClick={() =>
          openDeleteDialog(
            row.noBps
            // row.knowledgeProses.id_tipe_km
          )
        }
      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <i className="fas fa-trash text-danger"></i>
        </span>
      </a> */}
    </>
  );
}
